import config from "config";

const BASE_URL = config.get('api.messaging');

export const AUTOMATION_API_ENDPOINTS = {

  GetAutomationSettings: `${BASE_URL}/GetAutomationSettings`,
  AddUpdateAutomationSetting: `${BASE_URL}/AddUpdateAutomationSetting`,
  DeleteAutomationSetting: (automationId: number) => `${BASE_URL}/DeleteAutomationSetting/${automationId}`,
  UpdateAutomationStatus: `${BASE_URL}/UpdateAutomationStatus`,
  GetTaskLogs: `${BASE_URL}/get-task-logs`,
  GetReadyToSendTaskData: `${BASE_URL}/get-ready-to-send-task-data`,
  GetTextLogs: `${BASE_URL}/GetTextLogs`,
  GetReadyToSendTextData: `${BASE_URL}/GetReadyToSendTextData`,
  GetEmailLogs: `${BASE_URL}/GetEmailLogs`,
  GetReadyToSendEmailData: `${BASE_URL}/GetReadyToSendEmailData`,
  GetWorkOrderStatuses: `${BASE_URL}/GetWorkOrderStatuses`,
  GetAutomationDepartments: `${BASE_URL}/GetAutomationDepartments`,

};


export const AutomationConstant = {
  textMessageLimit: 500,

  emailPreHeaderLimit: 100,
  emailSubjectLimit: 200,

  taskNotesLimit: 500,
  taskSubjectLimit: 150,

  departmentRequired: "Department is required.",
  emailMessageRequired: "Email message is required.",
  emailSubjectRequired: "Email subject is required.",
  textMessageRequired: "Text message is required.",
  triggerStatusCodeRequired: "Status code is required.",
  triggerStatusCodeAlreadyExist: "Status is already present.",

  unableToFetchSetting: 'Unable to fetch automation settings. Please try again.',
  unableToSaveSetting: 'Unable to save automation setting. Please try again.',
  unableToDeleteSetting: 'Unable to delete automation setting. Please try again.',
  unableToUpdateAutomationStatus: 'Unable to update automation status. Please try again later.',

  unableToFetchLogs: 'Unable to fetch automation logs. Please try again.',
  unableToOpenAddDrawer: 'Unable to open add settings drawer. Please try again.',
  unableToOpenEditDrawer: 'Unable to open edit drawer. Please try again.',

  unableToFetchWorderOrderStatus: 'Unable to fetch work order statuses. Please try again.',

  MaximumLengthAllowed: (maxLength: Number) => `Maximum ${maxLength}  characters allowed.`,
  GetDefaultSettingSpName: "[TextAutomation].[spGetDefaultSetting]",
  DefaultMessage: `Hi, @CustomerName, the status of @JobDescription on shop ticket @JobId has been updated to @JobStatus.`
    + ` This job is one of @JobCount total jobs. As each job is completed, we will keep you updated, and you will receive a final notification when all work on the shop ticket is complete.`,
  DefaultTaskSubject: `Work order #@OrderId job updated to @JobStatus`
}
export const allowedCategories = ['email', 'call', 'text'];

export enum AutomationType {
  Email = 2,
  Text = 1,
  Task = 3,
}